module.exports = "https://cdn-assessment.mathletics.com/app/106/assets/images/a42db4a90ab6149827c1a853f82925d7.svg";